import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './HomePage';
import AdminPanelApp from './AdminPanelApp';
import UserDashboardApp from './UserDashboardApp';
import CustomerApp from './CustomerApp';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPanelApp />} />
        <Route path="/userdashboard" element={<UserDashboardApp />} />
        <Route path="/customer" element={<CustomerApp />} />
      </Routes>
    </Router>
  );
}

export default App;
